module.exports = __webpack_public_path__ + "assets/915bc1b88976cad5cf36710f3322337e.png";